const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max);

export const GRENADE_MAX_CHARGE_MS = 1000;
export const GRENADE_MIN_THROW_SPEED = 150;
export const GRENADE_MAX_THROW_SPEED = 840;
export const GRENADE_FLIGHT_DURATION_SECONDS = 1.2;
export const GRENADE_FUSE_MS = 1300;
export const GRENADE_BLAST_RADIUS = 180;

export const clampGrenadeChargeAmount = (chargeAmount: number): number => clamp(chargeAmount, 0, 1);

export const getGrenadeChargeAmount = (chargeTimeMs: number): number => {
  if (!Number.isFinite(chargeTimeMs) || chargeTimeMs <= 0) {
    return 0;
  }

  return clampGrenadeChargeAmount(chargeTimeMs / GRENADE_MAX_CHARGE_MS);
};

export const getGrenadeThrowSpeed = (chargeAmount: number): number => {
  const clampedCharge = clampGrenadeChargeAmount(chargeAmount);
  const chargeSquared = clampedCharge * clampedCharge;
  return GRENADE_MIN_THROW_SPEED + (chargeSquared * (GRENADE_MAX_THROW_SPEED - GRENADE_MIN_THROW_SPEED));
};

export const getGrenadeThrowDistance = (chargeAmount: number): number => {
  return getGrenadeThrowSpeed(chargeAmount) * GRENADE_FLIGHT_DURATION_SECONDS;
};

export const getGrenadeTravelDurationMs = (throwDistance: number, horizontalVelocity: number): number => {
  if (!Number.isFinite(throwDistance) || throwDistance <= 0) {
    return 0;
  }

  const travelSpeed = Math.abs(horizontalVelocity);
  if (!Number.isFinite(travelSpeed) || travelSpeed <= 0) {
    return 0;
  }

  return (throwDistance / travelSpeed) * 1000;
};
